// Mirror of RetroAssets.Utils/Classes/PasswordPolicy.cs, for live feedback only.
//
// The server re-validates every one of these rules and is the authority. Nothing
// is accepted because this file said so - a password that passes here can still
// be rejected by POST api/Password/Change, and that rejection wins.
//
// The character classes below are ASCII where the server uses the Unicode-aware
// char.IsUpper / IsLower / IsDigit / IsLetterOrDigit. The divergence only ever
// makes this file stricter than the server, never looser, so it cannot wave
// through something the server would refuse.

export const passwordRules = [
    {key: 'length', label: 'At least 8 characters', test: v => v.length >= 8},
    {key: 'upper', label: 'One uppercase letter', test: v => /[A-Z]/.test(v)},
    {key: 'lower', label: 'One lowercase letter', test: v => /[a-z]/.test(v)},
    {key: 'digit', label: 'One number', test: v => /[0-9]/.test(v)},
    {key: 'special', label: 'One symbol, for example ! ? # or @', test: v => /[^A-Za-z0-9]/.test(v)},
    {key: 'trim', label: 'No space at the start or end', test: v => v === v.trim()},
];

// Evaluates every rule against the candidate. Returns the rule list with a
// passed flag on each, plus an allPassed convenience flag.
export const evaluatePassword = (password, username) => {
    const value = password || '';

    const results = passwordRules.map(rule => ({
        key: rule.key,
        label: rule.label,
        passed: rule.test(value),
    }));

    if (username) {
        results.push({
            key: 'username',
            label: 'Different from your username',
            passed: value.toLowerCase() !== username.toLowerCase(),
        });
    }

    return {
        rules: results,
        allPassed: results.every(r => r.passed),
    };
};
